import { CircularProgress } from '@material-ui/core';
import React, { FC } from 'react';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { FontAwesomeSpriteButton } from 'src/modules/shared/components/FontAwesomeLocal';
import { useGetAlgebrakitSessionIdQuery } from 'src/modules/shared/slices/exercises/api/exercise';

type Props = {
  algebrakitExerciseId: string;
};

const RefreshButton: FC<Props> = ({ algebrakitExerciseId }) => {
  const {
    isSuccess: isSuccessAKSession,
    isFetching: isFetchingAKSession,
    isError: isErrorAKSession,
    refetch: refetchAKSession,
  } = useGetAlgebrakitSessionIdQuery(algebrakitExerciseId);

  const handleRefresh = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    refetchAKSession();
  };

  if (isFetchingAKSession) {
    return <CircularProgress />;
  }

  return (
    <FontAwesomeSpriteButton
      icon={SpriteIconsLight.REFRESH}
      iconSize="1x"
      color="gray"
      onClick={handleRefresh}
      disabled={isErrorAKSession || !isSuccessAKSession}
    />
  );
};

export default RefreshButton;
